import React from 'react';

import { Sprint } from '../../types';

import { EmptyState } from './EmptyState';
import { LoadingState } from './LoadingState';
import { TimelineView } from './TimelineView';

interface DailyProgressContentProps {
  isLoading: boolean;
  sprints: Sprint[] | undefined;
  selectedDate: Date;
  memberId?: string;
  employeeId?: string;
}

/**
 * Content section of the DailyProgress component
 * Handles loading, empty states, and renders the timeline view
 */
export const DailyProgressContent = React.memo(function DailyProgressContent({
  isLoading,
  sprints,
  selectedDate,
  memberId,
  employeeId,
}: DailyProgressContentProps): JSX.Element {
  if (isLoading) {
    return <LoadingState />;
  }

  if (!sprints?.length) {
    return <EmptyState />;
  }

  return (
    <TimelineView
      selectedDate={selectedDate}
      memberId={memberId}
      employeeId={employeeId}
    />
  );
});

DailyProgressContent.displayName = 'DailyProgressContent';
